import { AxiosInstance, AxiosResponse } from "axios";
import { ISituationProfessionnellePresentation } from "../../containers/DossierLocation/SituationProfessionnellePage/helpers";
import {
  DossierPiecesId,
  DossierParticulier,
  DossierParticulierTypeCompteEnum,
  DossiersLocationsApiFactory,
  DossiersProfessionnelsApiFactory,
  SituationPersonnelleDossierParticulier,
  SituationProfessionnelle,
  SituationProfessionnelleDossierParticulier,
  Fichier,
  DocumentsApiFactory,
} from "./swagger";
import { wrapError } from "../../helpers/utils";

export interface IApi {
  getDocument(id: number): Promise<Fichier>;
  deleteDocument(id: number): Promise<number>;
}

const create = (endpoint: string, axiosClient: AxiosInstance) => {
  const documentsApi = DocumentsApiFactory(
    { isJsonMime: () => true },
    endpoint,
    axiosClient
  );

  const getDocument = (id: number): Promise<Fichier> => {
    const promise: Promise<Fichier> = new Promise((resolve, reject) => {
      documentsApi
        .getDocument(id)
        .then((response: AxiosResponse<Fichier>) => {
          resolve(response.data);
        })
        .catch((error) => reject(wrapError(error)));
    });
    return promise;
  };

  const deleteDocument = (id: number): Promise<number> => {
    const promise: Promise<number> = new Promise((resolve, reject) => {
      documentsApi
        .deleteDocumentById(id)
        .then((response: AxiosResponse<void>) => {
          resolve(response.status);
        })
        .catch((error) => reject(wrapError(error)));
    });
    return promise;
  };
  return {
    getDocument,
    deleteDocument,
  };
};

export default create;
